export default __webpack_public_path__ + "static/media/My_car_website_images-11_7.31ee1869.webp";